import store from '@/store'

// A/B chatbot switch for the internal ChatGPT comparison (Oct 2026).
// A = the live chatbot (VUE_APP_CHATBOT_API_URL), B = the test app
// (VUE_APP_CHATBOT_TEST_URL). Only admins and the "Chatbot Test" organisation
// can use B, the same rule as the Chatbot item in TheDrawer.vue; everyone else
// always gets A. Without VUE_APP_CHATBOT_TEST_URL the switch does not exist.
const BACKEND_KEY = 'capacio-chatbot-backend'
export const LIVE_URL = process.env.VUE_APP_CHATBOT_API_URL
const TEST_URL = process.env.VUE_APP_CHATBOT_TEST_URL || ''

export function canUseTestBackend () {
  if (!TEST_URL) return false
  const user = (store.state.USER && store.state.USER.user) || {}
  return !!store.getters['ADMIN/isLoggedAdminIn'] || user.organisationName === 'Chatbot Test'
}

export function getBackend () {
  let saved = null
  try {
    saved = localStorage.getItem(BACKEND_KEY)
  } catch (err) { /* storage blocked: stay on A */ }
  return saved === 'B' && canUseTestBackend() ? 'B' : 'A'
}

export function setBackend (value) {
  try {
    localStorage.setItem(BACKEND_KEY, value === 'B' ? 'B' : 'A')
  } catch (err) { /* storage blocked: the choice just isn't remembered */ }
}

// Base URL for chat calls: the test app on B, the live chatbot otherwise.
export function chatbotBaseUrl () {
  return getBackend() === 'B' ? TEST_URL : LIVE_URL
}
